const BEACON_BAR_ORG_ID = process.env.GATSBY_BEACON_BAR_ORG_ID;
const BEACON_BAR_SDK_URL = "https://cdn.ai.greythr.com/sdk/latest.js";

const isEditableTarget = (target) => {
  if (!(target instanceof Element)) return false;

  const tag = target.tagName;
  if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") {
    return true;
  }

  if (target.isContentEditable) return true;

  return Boolean(target.closest('[contenteditable="true"]'));
};

const isSlashKey = (event) =>
  event.key === "/" || (event.code === "Slash" && !event.shiftKey);

const registerSearchKeyboardShortcut = () => {
  if (
    typeof window === "undefined" ||
    window.__beaconBarSearchShortcutRegistered
  ) {
    return;
  }

  window.__beaconBarSearchShortcutRegistered = true;

  window.addEventListener(
    "keydown",
    (event) => {
      if (
        !isSlashKey(event) ||
        event.metaKey ||
        event.ctrlKey ||
        event.altKey
      ) {
        return;
      }

      const target = event.target;
      const isNavosSearchTrigger =
        target instanceof Element &&
        target.closest("[data-navos-search-trigger]");

      if (isEditableTarget(target) && !isNavosSearchTrigger) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      openBeaconBarSearch();
    },
    true,
  );
};

/** Load the BeaconBar SDK once (safe to call multiple times). */
export const initBeaconBar = () => {
  if (typeof window === "undefined" || !BEACON_BAR_ORG_ID) return;

  registerSearchKeyboardShortcut();

  if (window.BeaconBar?.orgId) return;

  (function (b, e, a, c, o, n) {
    const stubOpen = () => {
      b[c].opened = true;
    };
    const stubOpenChat = () => {
      b[c].chatRequested = true;
    };

    b[c] = {
      orgId: n,
      user: {
        identifier: "greythr",
      },
      __stubOpen: stubOpen,
      open: stubOpen,
      openChat: stubOpenChat,
      domains: {
        cdnUrl: "cdn.ai.greythr.com",
        apiUrl: "edge.ai.greythr.com",
      },
    };

    const s = e.createElement(a);
    s.src = BEACON_BAR_SDK_URL;
    s.async = true;
    s.type = "module";
    s.onload = () => {
      if (b[c].chatRequested && typeof b[c].openChat === "function") {
        b[c].openChat();
        b[c].chatRequested = false;
      }

      if (b[c].opened && typeof b[c].open === "function") {
        b[c].open();
      }
    };

    const d = e.createElement(o);
    d.id = "beacon-user";
    e.body.appendChild(d);
    e.head.appendChild(s);
  })(window, document, "script", "BeaconBar", "div", BEACON_BAR_ORG_ID);
};

/** Opens the BeaconBar command/search palette. */
export const openBeaconBarSearch = () => {
  if (typeof window === "undefined") return;

  initBeaconBar();
  if (!window.BeaconBar) return;

  window.BeaconBar.open?.();

  if (window.BeaconBar.open !== window.BeaconBar.__stubOpen) return;

  const retry = setInterval(() => {
    if (!window.BeaconBar) {
      clearInterval(retry);
      return;
    }

    window.BeaconBar.opened = true;

    if (window.BeaconBar.open !== window.BeaconBar.__stubOpen) {
      window.BeaconBar.open();
      clearInterval(retry);
    }
  }, 200);
  setTimeout(() => clearInterval(retry), 10000);
};

/** Opens the Navos AI chat panel. */
export const openBeaconBarChat = () => {
  if (typeof window === "undefined") return;

  initBeaconBar();

  window.BeaconBar?.openChat?.();
};
